/**
 * SEO/local business constants — single source of truth for site metadata.
 */
export const BIZ = {
  name: "Wynridge Exterior Cleaning",
  legalName: "Wynridge Exterior Cleaning, LLC",
  phone: "(615) 519-2629",
  phoneTel: "+16155192629",
  phoneSmsHref: "sms:+16155192629",
  email: "wynridgeexteriorcleaning@gmail.com",
  city: "Goodlettsville",
  state: "Tennessee",
  stateShort: "TN",
  zip: "37072",
  region: "Middle Tennessee",
  hours: "24 / 7 — call or request a quote any time",
  gbpUrl: "https://maps.app.goo.gl/bZhL14eB2cgkkjoQ8?g_st=ic",
  bbbUrl: "", // Owner: paste your BBB profile URL here to link the BBB badge directly to your profile
  domain: "wynridgeexteriorcleaning.com",
  siteUrl: "https://wynridgeexteriorcleaning.com",
  logo: "/wynridge-logo.png?v=2",
  responseTime: "the same day, often within an hour",
  serviceAreas: [
    "Goodlettsville",
    "Hendersonville",
    "Madison",
    "White House",
    "Greenbrier",
    "Cottontown",
    "Gallatin",
  ],
};

export const SITE_TITLE_SUFFIX = ` | ${BIZ.name}`;

// Structured-data (JSON-LD) — LocalBusiness schema for the whole site
export const localBusinessJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${BIZ.siteUrl}/#business`,
  name: BIZ.name,
  image: `${BIZ.siteUrl}${BIZ.logo}`,
  telephone: BIZ.phone,
  email: BIZ.email,
  url: BIZ.siteUrl,
  address: {
    "@type": "PostalAddress",
    addressLocality: BIZ.city,
    addressRegion: BIZ.stateShort,
    postalCode: BIZ.zip,
    addressCountry: "US",
  },
  areaServed: BIZ.serviceAreas.map((c) => ({
    "@type": "City",
    name: `${c}, ${BIZ.stateShort}`,
  })),
  openingHours: "Mo-Su 00:00-23:59",
  sameAs: [BIZ.gbpUrl].filter(Boolean),
  priceRange: "$$",
});
